import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { getPaymentMethodText, parseFullName, parseNumber, parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { Typography } from '@mui/material';

const SubscriptionInfo = ({ subscription }) => {
    const { firstName, lastName } = useSelector(userSelectors.getInternalUser);

    const shareValue = useMemo(
        () => subscription?.investmentCharacteristics?.shareValue || 0,
        [subscription]
    );
    const investingSum = useMemo(
        () => subscription?.investmentCharacteristics?.investingSum || 0,
        [subscription]
    );

    return subscription?.investmentFund?.evergreen ? (
        <Typography gutterBottom>
            <b>{parseFullName({ firstName, lastName })}</b> {texts.YOU_HAVE_INVESTED}{' '}
            <b>{parseSum(investingSum)}</b> {texts.INTO_THE_FUND}{' '}
            <b>{subscription.investmentFund.name}</b> {texts.COMMERCIALISED_BY}{' '}
            <b>{subscription.investmentFund.promoter?.name}</b>. {texts.SGP_WILL_SIGN_BS}{' '}
            <b>
                {getPaymentMethodText(subscription?.bankingStatement?.paymentMethod).toLowerCase()}
            </b>{' '}
            {texts.AMOUNTING}{' '}
            <b>
                {parseSum(
                    investingSum +
                        (subscription?.investmentCharacteristics?.admissionFee / 100) * investingSum
                )}
            </b>{' '}
            {texts.YOUR_DOCUMENTS_VALIDATION} {texts.CONFIRMATION_EMAIL_PENDING}
        </Typography>
    ) : (
        <React.Fragment>
            <Typography gutterBottom>
                {texts.YOU_HAVE_INVESTED[0].toUpperCase() + texts.YOU_HAVE_INVESTED.slice(1)}{' '}
                <b>{parseSum(investingSum)}</b> {texts.REPRESENTING}{' '}
                <b>{parseNumber(investingSum / shareValue)}</b> {texts.FUND_SHARES}{' '}
                <b>{subscription.investmentFund.name}</b>.
            </Typography>
            <Typography gutterBottom>{texts.SIGNED_BY_SGP}</Typography>
        </React.Fragment>
    );
};

SubscriptionInfo.propTypes = { subscription: PropTypes.object };

export default SubscriptionInfo;
